import { render, staticRenderFns } from "./ChangeFrontDisplay.vue?vue&type=template&id=9a61c250&scoped=true&"
import script from "./ChangeFrontDisplay.vue?vue&type=script&lang=ts&"
export * from "./ChangeFrontDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeFrontDisplay.vue?vue&type=style&index=0&id=9a61c250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a61c250",
  null
  
)

export default component.exports